import { StyleSheet, Text, View, ActivityIndicator } from 'react-native'
import React from 'react'
import { ActionButton, LabledTextField } from '../SharedWidgets/LoginAndSignup'
import { navStack } from '../../Types/uitypes';
import { useForgotStore } from './Store';
import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { RootStackParamList } from '../../Types/uitypes';

type NavigationProp = RouteProp<
    RootStackParamList,
    "ForgotPasswordScreen"
>;

export default function ForgotPasswordScreen() {

    const navigation = useNavigation<navStack>();
    const route = useRoute<NavigationProp>();
    const { email } = route.params;

    const { showLoading,
        toggleLoading,
        otpEntryValue,
        setEntryValue,
        verifyOtp
    } = useForgotStore()

    async function handleVerifyOtp() {
        if (otpEntryValue != "") {
            toggleLoading()
            verifyOtp(email, () => {
                navigation.navigate("PasswordResetScreen", { email })
            })
        }
    }

    return (
        <View style={styles.root}>
            <Text
                style={{ fontFamily: 'Poppins_700Bold', fontSize: 24, textAlign: "center" }}
            >
                Verification code sent Registered Email
            </Text>
            <LabledTextField
                title='Verificaton Code sent'
                hint='Enter 6-digit code'
                value={otpEntryValue}
                onValueChange={setEntryValue}
            />
            <ActionButton
                label='Verify' onClick={handleVerifyOtp}
            />
            {
                showLoading &&
                <ActivityIndicator size="large" color="#007AFF" />
            }
        </View>
    )
}


const styles = StyleSheet.create({
    root: {
        backgroundColor: "white",
        flex: 1,
        gap: 12,
        paddingHorizontal: 12,
        paddingVertical: 12,
    }
});